import React from 'react';
// Components
import ManageMerch from 'components/common/ManageMerch';

const ManageAthleteMerch: React.FC = () => {
  return <ManageMerch />;
};

export default ManageAthleteMerch;
